import { IUiIcon } from '../../../types/ui'

export const IconShare2 = (
	{
		size = 24,
		imgSize = 24,
		fill = 'none',
		stroke = 'currentColor'
	}: IUiIcon
) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
		     width={`${size}px`}
		     height={`${size}px`}
		     viewBox={`0 0 ${imgSize} ${imgSize}`}
		     fill={fill}
		     stroke={stroke}
		     strokeWidth="2"
		     strokeLinecap="round"
		     strokeLinejoin="round"
		     className="feather feather-share-2"
		>
			<circle cx="18" cy="5" r="3"></circle>
			<circle cx="6" cy="12" r="3"></circle>
			<circle cx="18" cy="19" r="3"></circle>
			<line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
			<line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
		</svg>
	)
}